import React, { useState } from "react";
import { RxPencil1 } from "react-icons/rx";
import { Link } from "react-router-dom";
import { MdAdd, MdBrandingWatermark, MdLocationCity, MdOutlineDelete, MdOutlineGroup } from "react-icons/md";
import { observer } from "mobx-react";
import Filter from "./BrandFilter/Filter";
import ReactPaginate from 'react-paginate';
import { BrandStore, useBrandStore, BrandStoreContext } from "./store/BrandStore";
import { useAuthStore } from "../Auth/store/Auth";
import { useEffect } from "react";
import Lightbox from "react-awesome-lightbox";
// You need to import the CSS only once
import "react-awesome-lightbox/build/style.css";
import dem05 from "../assets/images/2.png"
import { toast, ToastContainer } from "react-toastify";

const BrandManagement = () => {
    const store = new BrandStore({
        isloading: true,
        editloading: false
    });
    return (
        <BrandStoreContext.Provider value={store}>
            <Screen />
        </BrandStoreContext.Provider>
    )
}
export default BrandManagement;


const Screen = observer(() => {
    const {
        Brand,
        loadcity,
        LoadBrand,
        nolist,
        Citypopup,
        BulkDelete,
        BulkstatusChange,
        brandLoader,
        // setallBrand,
        // allbrand,
        setPaginationPage,
        setalldeactivate,
        alldeactivate,
        getBrandList,
        getFilterBrand,
        TotalPages,
        setbrandpopup,
        brandpopup,
        deletepopup,
        setdeletepopup,
        setdelateLoader,
        delateLoader,
        statusChange,
        setstatuspopup,
        getid,
        getstatus,
        deletefunction,
        setchecked,
        checkeddd,
        getToken
    } = useBrandStore();

    const { adminAuthApproved, admin_permissions } = useAuthStore();

    useEffect(() => {
        if (adminAuthApproved) {
            getToken(localStorage.getItem("Admintoken"));
        }

    }, [adminAuthApproved]);

    const [currentPage, setCurrentPage] = useState(0);
    const [lightboxIsOpen, setLightboxIsOpen] = useState(false);
    const [allbrand, setallBrand] = useState([])
    const [Imagearray, setImagearray] = useState([]);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [isatend, setisatend] = useState(false);
    const [isAtBeginning, setisAtBeginning] = useState(false);
    const [Imagelength, setImagelength] = useState("");

    const prevSlide = (image) => {
        setCurrentSlide((prev) => (prev === 0 ? image.length - 1 : prev - 1));
        setisAtBeginning(currentSlide === 0)

    };
    const nextSlide = (image) => {
        setCurrentSlide((prev) => (prev === image.length - 1 ? 0 : prev + 1));
        setisatend(currentSlide === image.length - 1)
    };
    // const [checkeddd, setchecked] = useState(false)

    const [photoIndex, setPhotoIndex] = useState("");
    const ITEMS_PER_PAGE = 10;
    const handlePageChange = ({ selected }) => {
        setPaginationPage(selected + 1);
        getFilterBrand();
        setCurrentPage(selected);
    };

    const handleClick = () => {
        const element = document.getElementById("tablescroll");
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    }
    const startIndex = currentPage * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    const brand = Brand?.slice(startIndex, endIndex);
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const openLightbox = (index) => {
        setLightboxIsOpen(true);
    };

    const closeLightbox = () => {
        setLightboxIsOpen(false);
    };
    const handleImageError = (event) => {
        // This function will be called when the image fails to load
        event.target.src = dem05; // Replace with the path to your default image
    };

    const checkAllCheckboxes = () => {
        setallBrand([]);
        // Get all checkboxes with the same name attribute
        var checkboxes = document.getElementsByName('myCheckbox');

        if (checkeddd) {
            for (var i = 0; i < checkboxes.length; i++) {
                checkboxes[i].checked = false;
            }
            setallBrand([]);
        } else {
            var emails = [];
            var commaSeparatedEmails = [];
            // var emailArray = emailString.split(",").map((email) => email.trim());
            // Loop through each checkbox and check it
            for (var i = 0; i < checkboxes.length; i++) {
                checkboxes[i].checked = true;
                var emailValues = checkboxes[i].value.split(',');
                if (emailValues.length > 1) {
                    commaSeparatedEmails.push(...emailValues);
                } else {
                    var emailValue = emailValues[0].trim();
                    if (emailValue !== '' && !emails.includes(emailValue)) {
                        emails.push(emailValue);
                    }

                }
            }
            setallBrand((prevEmails) => [...prevEmails, ...emails, ...commaSeparatedEmails]);
        }

    }
    const isallcheck = (e) => {
        var checkboxes = document.getElementsByName('myCheckbox');
        for (var i = 0; i < checkboxes.length; i++) {
            var updatedEmails = Array.from(checkboxes)
                .filter((checkbox) => checkbox.checked)
                .flatMap((checkbox) => checkbox.value.split(',').map((email) => email.trim()));
            setallBrand(updatedEmails);
            if (!checkboxes[i].checked) {
                setchecked(false)
                return
            }
            else {
                setchecked(true)
            }

        }
    }

    return (
        <>
          <div className="flex justify-between mt-[51px] ">
                <div className=" mb-4">
                    <p className=" text-2xl font-semibold">Brand Management</p>
                    <p className=" opacity-80 text-sm">Home / brand</p>
                </div>
                <div>
                    <Link
                        to="./addbrandmanagement"
                        className="btn btn-sm bg-[#000] text-color_theme text-sm hover:bg-[#000]"
                    >
                        <MdAdd />
                        Add Brand
                    </Link>
                </div>
            </div>
            <Filter />

            <div className="flex justify-between items-center py-2">
                <div className="ml-3">
                    <label className=" font-extrabold">
                        <input className="mr-2" checked={checkeddd} type="checkbox" name="selectall"
                            onClick={() => { checkAllCheckboxes(); setchecked(!checkeddd) }}


                        />
                        Select All
                    </label>
                </div>
                <div className="space-x-3 flex justify-center">
                    {/* { allemail.length !== 0 && */}
                    {/* <label
                        htmlFor="emailpopup"
                        className={`btn btn-md ${allbrand.length == 0 && "opacity-50"}  bg-[#000] text-color_theme text-sm hover:bg-[#000]`}
                    // onClick={() => setPopupemail(true)}
                    >
                        All Deactivate
                    </label > */}
                    <label class={`relative ${allbrand.length == 0 && "opacity-50"}  inline-flex items-center  cursor-pointer`}>
                        {admin_permissions.brand === 1 ?
                            <input disabled={allbrand.length == 0 && true} onClick={() => { setalldeactivate(); BulkstatusChange(allbrand) }} type="checkbox" class="sr-only peer" />
                            :
                            <input disabled onClick={() => {
                                toast.warning("You have no permissions to edit.")

                            }} type="checkbox" class="sr-only peer" />
                        }

                        <div class="w-7 h-3 bg-gray-200 peer-focus:outline-none peer-focus:ring-1 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                        <span class="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300"> {!alldeactivate ? "All Activate" : "All Deactivate"}
                        </span>
                    </label>

                    {/* 
                    <label
                        // htmlFor="emailpopup" 
                        className={`btn btn-md ${allbrand.length == 0 && "opacity-50"}  bg-[#000] text-color_theme text-sm hover:bg-[#000]`}

                    // onClick={()=>setPopupemail(true)}
                    >
                        All Delete

                    </label > */}
                    <label class={`relative ${allbrand.length == 0 && "opacity-50"}  justify-center text-center   inline-flex   cursor-pointer`}>
                        {admin_permissions.brand === 1 ?

                            <button disabled={allbrand.length == 0 && true} className="flex" onClick={() => { BulkDelete(allbrand) }}  >
                                <MdOutlineDelete className="text-[red]" />
                                <span class="ms-1 text-sm font-medium text-center text-gray-900 dark:text-gray-300">
                                    All Delete
                                </span>
                            </button>
                            :
                            <button disabled={allbrand.length == 0 && true} className="flex" onClick={() => { toast.warning("You have no permissions to edit.") }}  >
                                <MdOutlineDelete className="text-[red]" />
                                <span class="ms-1 text-sm font-medium text-center text-gray-900 dark:text-gray-300">
                                    All Delete
                                </span>
                            </button>
                        }

                    </label>
                    {/* } */}


                </div>
            </div>
            <div className="card bg-base-100 shadow-md p-6 mt-8">
                <div className="overflow-x-auto w-full">
                    <table id="tablescroll" className="table table-zebra w-full">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Brand ID</th>
                                <th>Logo</th>
                                <th>Brand</th>
                                <th>SEO-Friendly URL</th>
                                <th>status</th>
                                <th>Action</th>
                            </tr>
                        </thead>

                        <tbody className="text-sm relative">
                            {LoadBrand &&
                                <>
                                    <tr>
                                        <td colSpan={7} className="animate-pulse py-6"></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={7} className="animate-pulse py-6"></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={7} className="animate-pulse py-6"></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={7} className="animate-pulse py-6"></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={7} className="animate-pulse py-6"></td>
                                    </tr>
                                </>
                            }
                            {
                                (brand.length === 0 ? Brand : brand)?.map((data, index) => (
                                    <tr key={index} className="capitalize">
                                        <td>

                                            {/* {!data?.is_refunded && */}
                                            <input
                                                // value={`${data?.players?.mate?.email} ? ${data?.players?.user?.email}`} 
                                                value={data?.id}
                                                onChange={(e) => { setchecked(false); isallcheck(e.target.value); }}
                                                type="checkbox"
                                                name="myCheckbox"
                                            />
                                            {/* } */}
                                        </td>
                                        <td>
                                            {currentPage * ITEMS_PER_PAGE + data?.id}
                                        </td>
                                        <td
                                            onClick={() => { setImagearray(data.logo_image); openLightbox() }}

                                        >
                                            <label
                                                htmlFor="imagecarousel"
                                                className=" flex space-x-[-5px] cursor-pointer"
                                                title="Delete"

                                            >
                                                {


                                                    <>
                                                        <img

                                                            onError={handleImageError}
                                                            alt="ProductCatalog Image" className="w-[55px] bg-white transition duration-300 hover:opacity-70 rounded-xl bBanner-[2px] p-1 bBanner-[#d7d7d7] cursor-pointer h-[55px]" crossOrigin="anonymous" src={BASE_URL + `/uploads/brand/${data?.logo_image}`} />
                                                    </>

                                                }





                                            </label>




                                        </td>

                                        <td>
                                            {data?.name ?? "N/A"}
                                        </td>
                                        <td className="hover:text-color_theme">
                                            <a target="_blank" href={data?.seo_url}>{data?.seo_url ?? "N/A"}</a>

                                        </td>


                                        <th >
                                            <div className="flex space-x-3">
                                                {admin_permissions.brand === 1 ?
                                                    <label
                                                        title="Change Status"
                                                        htmlFor="my-modal-5"
                                                        className={`btn capitalize Active" ${data?.is_active === 1 ? "bg-[#5dff5d] hover:bg-[#5dff5d]" : "bg-warning hover:bg-warning"}  text-[#000] border-hidden  btn-xs`}

                                                        onClick={(e) => {
                                                            getid(data?.id);
                                                            setbrandpopup(true);
                                                            getstatus(data?.is_active === 1 ? 0 : 1);
                                                        }}
                                                    >
                                                        {data?.is_active === 1 ? "Active" : "Inactive"}
                                                    </label>
                                                    :
                                                    <label
                                                        title="Change Status"
                                                        htmlFor="my-modal-5"
                                                        className={`btn capitalize Active" ${data?.is_active === 1 ? "bg-[#5dff5d] hover:bg-[#5dff5d]" : "bg-warning hover:bg-warning"}  text-[#000] border-hidden  btn-xs`}

                                                        onClick={(e) => {
                                                            toast.warning("You have no permissions to edit.")
                                                        }}
                                                    >
                                                        {data?.is_active === 1 ? "Active" : "Inactive"}
                                                    </label>
                                                }
                                            </div>

                                        </th>
                                        <th >
                                            <div className="flex space-x-3">

                                                <div className="flex items-center space-x-3">
                                                    {admin_permissions.brand === 1 ?
                                                        <label
                                                            htmlFor="deletecity"
                                                            className=" text-[#d02c2c] cursor-pointer"
                                                            title="Delete"
                                                            onClick={() => { setdeletepopup(true); getid(data?.id) }}
                                                        >
                                                            <MdOutlineDelete />
                                                        </label>
                                                        :
                                                        <label
                                                            htmlFor="deletecity"
                                                            className=" text-[#d02c2c] cursor-pointer"
                                                            title="Delete"
                                                            onClick={() => { toast.warning("You have no permissions to edit.") }}
                                                        >
                                                            <MdOutlineDelete />
                                                        </label>
                                                    }
                                                    {admin_permissions.brand === 1 ?
                                                        <button title="Edit">
                                                            <Link to={`/brandmanagement/${data?.id}`}>
                                                                <RxPencil1 />
                                                            </Link>
                                                        </button>
                                                        :
                                                        <button onClick={() => toast.warning("You have no permissions to edit.")} title="Edit">

                                                            <RxPencil1 />

                                                        </button>
                                                    }

                                                </div>
                                            </div>

                                        </th>

                                    </tr>
                                ))
                            }

                            {nolist &&
                                <tr>
                                    <td colSpan={7} className="my-10 text-center">
                                        <MdOutlineGroup className=" text-[#dedede] text-8xl mx-auto" />
                                        <p className=" font-semibold text-lg">No brand Found</p>
                                        <Link
                                            to="./addbrandmanagement"
                                            className="btn btn-sm mt-4 bg-[#000] text-color_theme text-sm hover:bg-[#000]"
                                        >
                                            <MdAdd />
                                            Add Brand
                                        </Link>
                                    </td>
                                </tr>}
                        </tbody>
                    </table>
                    {/* {!city?.length == 0 && */}

                    <ReactPaginate
                        initialPage={0}
                        pageCount={Math.ceil(TotalPages)}
                        pageRangeDisplayed={5}
                        marginPagesDisplayed={2}
                        onPageChange={handlePageChange}
                        onClick={handleClick}
                        containerClassName={'pagination'}
                        activeClassName={'active'}

                    />
                    {/* } */}

                    {/* status change model start */}
                    {/* <div className="modal">
            <div className="modal-box relative">
              <label
                htmlFor="my-modal-5"
                className="btn btn-sm btn-circle absolute right-2 top-2"
              >
                ✕
              </label>
              <h3 className="text-lg font-bold text-center">
                Are you sure you want to change Status ?
              </h3>
              <div className="modal-action justify-center">
                      <label
                        htmlFor="my-modal-5"
                        className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4"
                        onClick={() => statusChange()}
                      >
                        Yes
                      </label> 
                <label htmlFor="my-modal-5" className="btn btn-md bg-[#000] text-color_theme text-sm hover:bg-[#000]">
                  No
                </label>
              </div>
            </div>
          </div> */}
                    {/* status change model end */}
                    {lightboxIsOpen &&
                        <>
                            <input type="checkbox" id="imagecarousel" className="modal-toggle" />
                            <div className="modal w-full">
                                <div className="modal-box relative">
                                    <label

                                        className="btn btn-sm btn-circle absolute right-2 top-2"
                                        onClick={() => { setdelateLoader(false); setCurrentSlide(0); setLightboxIsOpen(false) }}
                                    >
                                        ✕
                                    </label>
                                    <div className="modal-action justify-center">
                                        <div className="carousel w-full">
                                            {/* {Imagearray.map((image, i) => ( */}
                                            <div
                                                // key={i}
                                                // id={`slide${i}`}
                                                className={`carousel-item relative w-full `}
                                            >
                                                <img
                                                    onError={handleImageError}
                                                    crossOrigin="anonymous" src={BASE_URL + `/uploads/brand/${Imagearray}`} className="w-full" />
                                            </div>
                                            {Imagearray.length > 1 &&
                                                <div className="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">

                                                    <button disabled={isAtBeginning} onClick={() => { prevSlide(Imagearray); setImagelength(Imagearray); }} className={`btn btn-circle`}>
                                                        ❮
                                                    </button>

                                                    <button disabled={isatend} onClick={() => { nextSlide(Imagearray); setImagelength(Imagearray); }} className={`btn btn-circle`}>
                                                        ❯
                                                    </button>



                                                </div>
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>

                    }
                    {deletepopup &&
                        <>
                            <input type="checkbox" id="deletecity" className="modal-toggle" />
                            <div className="modal">
                                <div className="modal-box relative">
                                    <label

                                        className="btn btn-sm btn-circle absolute right-2 top-2"
                                        onClick={() => { setdelateLoader(false); setdeletepopup(false) }}
                                    >
                                        ✕
                                    </label>
                                    <h3 className="text-lg font-bold text-center">
                                        Are you sure you want to Delete this Brand
                                    </h3>
                                    <div className="modal-action justify-center">
                                        {/* <label
                                            htmlFor="deletecity"
                                            className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4"
                                            onClick={() => deletefunction()}
                                        >
                                            Yes
                                        </label> */}
                                        {!delateLoader ?
                                            <label

                                                className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4"
                                                onClick={() => deletefunction()}
                                            >
                                                Yes
                                            </label> :
                                            <button
                                                // type="submit"
                                                disabled
                                                className="flex items-center bg-color_theme px-3 mx-5 rounded-md"
                                            // onClick={() => {
                                            //   PostMatchscore();
                                            // }}
                                            >
                                                Yes..
                                                <svg
                                                    className="animate-spin mr-1 h-5 w-5 text-white"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <circle
                                                        className="opacity-25"
                                                        cx="12"
                                                        cy="12"
                                                        r="10"
                                                        stroke="currentColor"
                                                        strokeWidth="4"
                                                    ></circle>
                                                    <path
                                                        className="opacity-75"
                                                        fill="currentColor"
                                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                    ></path>
                                                </svg>
                                            </button>}
                                        <label
                                            onClick={() => setdeletepopup(false)}
                                            className="btn btn-md bg-[#000] text-color_theme text-sm hover:bg-[#000]">
                                            No
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </>

                    }
                    {brandpopup &&
                        <>
                            <input type="checkbox" id="my-modal-5" className="modal-toggle" />
                            <div className="modal">
                                <div className="modal-box relative">
                                    <label

                                        className="btn btn-sm btn-circle absolute right-2 top-2"
                                        onClick={() => setbrandpopup(false)}
                                    >
                                        ✕
                                    </label>
                                    <h3 className="text-lg font-bold text-center">
                                        Are you sure you want to change Status ?
                                    </h3>
                                    <div className="modal-action justify-center">
                                        {!brandLoader ? <label

                                            className="btn btn-md bg-color_theme text-[#000] text-sm hover:text-color_theme hover:bg-[#000] ml-4"
                                            onClick={() => statusChange()}
                                        >
                                            Yes
                                        </label> :
                                            <button
                                                // type="submit"
                                                disabled
                                                className="flex items-center bg-color_theme px-3 mx-5 rounded-md"
                                            // onClick={() => {
                                            //   PostMatchscore();
                                            // }}
                                            >
                                                Yes..
                                                <svg
                                                    className="animate-spin mr-1 h-5 w-5 text-white"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <circle
                                                        className="opacity-25"
                                                        cx="12"
                                                        cy="12"
                                                        r="10"
                                                        stroke="currentColor"
                                                        strokeWidth="4"
                                                    ></circle>
                                                    <path
                                                        className="opacity-75"
                                                        fill="currentColor"
                                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                    ></path>
                                                </svg>
                                            </button>}

                                        <label
                                            onClick={() => setbrandpopup(false)}
                                            // htmlFor="voidstatus"
                                            className="btn btn-md bg-[#000] text-color_theme text-sm hover:bg-[#000]"
                                        >
                                            No
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </>

                    }
                </div>
            </div>
        </>
    );
});

